import React from 'react';

const CartItem = ({ item, onQuantityChange, onRemove }) => {
  const formattedTotal = (item.price * item.quantity).toFixed(2);
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-4 py-4 border-b border-gray-200">
      <div className="flex items-center gap-4 flex-1">
        <div className="w-24 h-24 flex-shrink-0 rounded-xl overflow-hidden bg-gray-50">
          <img 
            src={item.image} 
            alt={item.name} 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1">
          <h3 className="font-medium text-gray-900 leading-tight">{item.name}</h3>
          {item.description && (
            <p className="text-sm text-gray-500 line-clamp-2">{item.description}</p>
          )}
          {(item.selectedSize || item.selectedColor) && (
            <p className="text-xs text-gray-600 mt-1 space-x-2">
              {item.selectedSize && <span>Masa: {item.selectedSize}</span>}
              {item.selectedColor && <span>Ngjyra: {item.selectedColor}</span>}
            </p>
          )}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-3 flex-shrink-0">
        <div className="flex items-center justify-between sm:justify-start gap-3">
          <span className="text-xs uppercase tracking-wide text-gray-500 sm:hidden">Sasia</span>
          <div className="flex items-center border rounded-full overflow-hidden shadow-sm">
            <button 
              onClick={() => onQuantityChange(item.id, Math.max(1, item.quantity - 1))}
              className="px-3 py-1.5 text-gray-600 hover:bg-gray-100"
              aria-label="Zvogëlo sasitë"
            >
              -
            </button>
            <span className="px-4 py-1.5 min-w-[40px] text-center text-sm font-medium">{item.quantity}</span>
            <button 
              onClick={() => onQuantityChange(item.id, item.quantity + 1)}
              className="px-3 py-1.5 text-gray-600 hover:bg-gray-100"
              aria-label="Rrit sasitë"
            >
              +
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between sm:justify-end gap-3 w-full sm:w-auto">
          <div className="text-right">
            <span className="text-xs uppercase tracking-wide text-gray-500 block sm:hidden">Çmimi</span>
            <span className="text-base font-semibold text-gray-900">€{formattedTotal}</span>
          </div>
          <button 
            onClick={() => onRemove(item.id)}
            className="text-gray-400 hover:text-red-600 p-2"
            aria-label="Hiq produktin"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartItem;